export default __webpack_public_path__ + "static/media/IconDiffTemp.0bc01865.svg";